<template>
  <div class="lotteryComp">
    <TurnplateLottery
      v-bind="$attrs"
      v-on="$listeners"
      :isShowAwardTitle="isShowAwardTitle"
      @reportDraw="handleReportDraw"
    />
  </div>
</template>

<script>
import TurnplateLottery from '@/components/templates/common/TurnplateLottery';
import { mapState } from 'vuex';
export default {
  components: { TurnplateLottery },
  mounted() {
    this.$emit('reportEvent', {
      event: 'lottery_topic_expo',
      module_name: '1001'
    });
  },
  computed: {
    ...mapState('app', ['uiTheme']),
    isShowAwardTitle() {
      return this.uiTheme !== 'lalamove';
    }
  },
  methods: {
    handleReportDraw({ is_success }) {
      this.$emit('reportEvent', {
        event: 'lottery_button_click',
        module_name: '1001',
        button_name: this.$t
          ? this.$t('track.turnplate_btn')
          : '大转盘_抽奖按钮',
        is_success
      });
    }
  }
};
</script>

<style>
.lotteryComp {
  padding-top: 190px;
  padding-bottom: 22px;
}
</style>
